import { isRepositoryName } from "./isRepositoryName.js";
import { PrismicError } from "./PrismicError.js";
const getRepositoryEndpoint = (repositoryName) => {
  if (isRepositoryName(repositoryName)) {
    return `https://${repositoryName}.cdn.prismic.io/api/v2`;
  } else {
    throw new PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
  }
};
export {
  getRepositoryEndpoint
};
//# sourceMappingURL=getRepositoryEndpoint.js.map
